/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import DownloadIcon from '@mui/icons-material/Download';
import { Box, Button, Checkbox, Paper, Typography } from '@mui/material';
import { getAgreementTermById } from 'api/agreement-term/agreement-term.api';
import { useState } from 'react';
import { formatDate } from 'utils/format_date';

interface IfileDownload {
  base64: string;
  name: string;
  documenyType: string;
}

export default function CardHistoricoTermoAdesao({
  term,
  index,
  selectedHistoryTerms,
  handleSelectTerm,
}: {
  term: any;
  index: number;
  selectedHistoryTerms: any[];
  handleSelectTerm: (term: any) => void;
}) {
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    setIsLoading(true);
    try {
      const response = await getAgreementTermById(term.uuid);
      console.log(response);

      const file: IfileDownload = response.file as any;
      if (file && file.base64) {
        const byteCharacters = atob(file.base64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download =
          file.name || `termo-adesao-${formatDate(term.signatureAt)}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Paper
      key={index}
      sx={{
        overflow: 'hidden',
        borderRadius: '8px',
        marginBottom: '12px',
      }}
    >
      <Box
        sx={{
          padding: '16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <Checkbox
            color='primary'
            checked={selectedHistoryTerms.includes(term)}
            onChange={() => handleSelectTerm(term)}
          />
          <Box>
            <Typography variant='h6' fontWeight='bold'>
              {formatDate(term.signatureAt)}
            </Typography>
            <Typography fontSize='14px' color='#666'>
              Data da Assinatura - Representante Legal Municipal:{' '}
              {formatDate(term.municipalSignatureDate)}
            </Typography>
            <Typography fontSize='14px' color='#666'>
              Data da Assinatura - Representante Legal Estadual:{' '}
              {formatDate(term.stateSignatureDate)}
            </Typography>
            <Typography fontSize='14px' color='#666'>
              Data do Vencimento: {formatDate(term.dueAt)}
            </Typography>
          </Box>
        </Box>

        {/* Botão de ação */}
        <Button
          variant='outlined'
          endIcon={<DownloadIcon sx={{ fontSize: 20 }} />}
          onClick={() => handleDownload()}
          disabled={isLoading}
          sx={{
            height: '36px',
            minWidth: '120px',
            borderRadius: '8px',
            fontWeight: 'bold',
            color: '#1976D2',
            border: '1px solid #1976D2',
            textTransform: 'uppercase',
            '&:hover': {
              backgroundColor: '#E3F2FD',
              border: '1px solid #1565C0',
            },
          }}
        >
          {isLoading ? 'Baixando...' : 'Baixar Termo de Adesão'}
        </Button>
      </Box>
      {/* Status do Termo */}
      <Box
        sx={{
          backgroundColor: `${
            term.status === 'ATIVO'
              ? '#EAF2EA'
              : term.status === 'INATIVO'
              ? '#D32F2F0A'
              : '#ED6C020A'
          }`,
          padding: '8px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontWeight: 'bold',
          fontSize: '14px',
          color: `${
            term.status === 'ATIVO'
              ? '#123214'
              : term.status === 'INATIVO'
              ? '#D32F2F'
              : '#ED6C02'
          }`,
        }}
      >
        {term.status === 'Ativo' && '✔️'}
        {term.status === 'Bloqueado' && '⚠️'}
        {term.status === 'Inativo' && '❗'}
        <Typography fontWeight='400'>{`Situação: ${term.status}`}</Typography>
      </Box>
    </Paper>
  );
}
